import script from "./statusSubscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./statusSubscription.vue?vue&type=script&setup=true&lang=ts"

import "./statusSubscription.vue?vue&type=style&index=0&id=24154326&lang=css"

const __exports__ = script;

export default __exports__